// AdminMarketerConsultantPc.jsx — 마케터 1:1 관리 PC 화면 (2026-10-06 UX 3단계)
//   머리(제목·[변경 기록]) → 회사 고르기 → 탭 [배정 관리][1:1급여 정산 · 확인 N][상담자배분] → 탭 내용.
//   데이터·창은 페이지가 만든 훅(vm·board·actions·calc)을 받아 그리기만 한다(휴대폰 화면과 공유).
import React from 'react';
import { AssignmentBoard } from './AssignmentBoard';
import { MonthlyCalculationPanel } from './MonthlyCalculationPanel';
import { ConsultantSharePanel } from './ConsultantSharePanel';
import { CompanyTabs, MarketerConsultantTabs } from './MarketerConsultantTabs';
import { S } from '../AdminMarketerConsultantStyles';
import { stdHeaderRow, stdPageTitle, stdPageSubtitle } from '../adminlayout/designStandard';

export const PAGE_SUBTITLE = '1:1 직원을 마케터에게 배정하고, 매달 1:1급여를 계산해 마케터 정산서에 넣습니다.';

export function AdminMarketerConsultantPc({
  vm, board, actions, calc, history, today, tab, onTab, tabItems, integratedMenuId, pageTitle, isMobile = false,
}) {
  return (
    <div style={S.page}>
      <div style={stdHeaderRow(isMobile)}>
        <div>
          <h1 style={stdPageTitle}>{pageTitle}</h1>
          <div style={stdPageSubtitle}>{PAGE_SUBTITLE}</div>
        </div>
        <div style={S.topActions}>
          {vm.isIntegratedMode && <CompanyTabs vm={vm} styles={S} />}
          <button type="button" style={S.histBtn} onClick={history.openAll}>변경 기록</button>
        </div>
      </div>

      {!vm.isIntegratedMode && <CompanyTabs vm={vm} styles={S} />}

      <MarketerConsultantTabs tab={tab} onChange={onTab} pendingCount={calc.pendingChargeCount} items={tabItems} />

      {tab === 'assign' && (
        <section style={S.card}>
          <div style={S.sectionHead}>
            <div>
              <h2 style={S.sectionTitle}>1:1 배정</h2>
              <div style={S.sectionSub}>배정 줄을 누르면 담당 마케터 바꾸기·배정 끝내기·고치기를 할 수 있어요. 끌어다 놓아도 됩니다.</div>
            </div>
            <button type="button" style={S.primaryBtn} onClick={() => vm.openAdd(null)}>+ 새 배정</button>
          </div>
          {vm.loading ? (
            <div style={S.empty}>불러오는 중입니다.</div>
          ) : (
            <AssignmentBoard
              model={board}
              assignments={vm.assignments}
              today={today}
              onAdd={vm.openAdd}
              onOpen={actions.openDetail}
              onRequestAssign={actions.requestAssign}
              onMove={vm.openMove}
              onEnd={vm.openEnd}
              saving={vm.saving}
            />
          )}
        </section>
      )}

      {tab === 'charge' && (
        <MonthlyCalculationPanel calc={calc} integratedMenuId={integratedMenuId} onOpenRules={actions.requestRules} />
      )}

      {tab === 'share' && (
        <section style={S.card}>
          <ConsultantSharePanel companyCode={vm.activeTab} companyName={vm.activeCompanyName} integratedMenuId={integratedMenuId} />
        </section>
      )}
    </div>
  );
}
